// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__lKjIC","heading":"style_heading__UQtVW","tBlur1":"style_tBlur1__h8jMk","tBlur2":"style_tBlur2__KrLU5","testimonial":"style_testimonial__vLwNg"};